<template>
  <div
    :class="{
      search_table: modeView === 'table',
      '_sidebar-closed': !sidebarStatus
    }"
    class="search scrollable-pagination"
  >
    <header class="search-header">
      <div class="search-header__left">
        <view-switch :outerModeView="modeView" @toggleMode="handleToggleMode" />

        <search-query-summary />
      </div>
    </header>

    <search-result
      :modeView="modeView"
      :currentDocumentId="currentDocumentId"
      @card-click="onButtonCardClick"
    />

    <section class="search-sidebar" v-if="sidebarStatus">
      <div
        v-if="sidebarStatus === 'card'"
        class="m-nav-back"
        @click="toggleSidebar('')"
      >
        <svg width="20" height="20" class="m-nav-back__arrow">
          <use xlink:href="#chevron"></use>
        </svg>
      </div>

      <search-filter v-if="sidebarStatus !== 'card'" />

      <search-document-info
        v-if="currentDocumentId && sidebarStatus === 'card'"
        :document-id="currentDocumentId"
      />
    </section>
  </div>
</template>

<script>
/* eslint-disable */ 
import { mapGetters } from 'vuex';

import SearchResult from './SearchResult';
import SearchFilter from './SearchFilter';
import SearchDocumentInfo from './SearchDocumentInfo';
import SearchQuerySummary from './SearchQuerySummary';
import ViewSwitch from './ViewSwitch';

import LoaderCubics from '@@/shared/loaders/LoaderCubics';

export default {
  components: {
    LoaderCubics,
    SearchResult,
    SearchFilter,
    SearchDocumentInfo,
    SearchQuerySummary,
    ViewSwitch
  },

  data: () => ({
    currentDocumentId: null,
    sidebarBeforeCardState: ''
  }),

  computed: {
    ...mapGetters([
      'modeView',
      'sidebarStatus',
      'searchSessionStatus',
      'searchResults',
      'searchQuery'
    ])
  },

  watch: {
    $route: function(to, from) {
      let requestTo = (to.query && to.query.request)? to.query.request: ''
      let requestFrom = (from.query && from.query.request)? from.query.request: ''
      
      if(requestTo !== requestFrom){
        this.$router.push({ 
          query:{
            request: requestTo
          }
        }).catch(err => {}) // To remove error on navigation on the same page
        this.$store.dispatch('setTextQueryParams', {
          text: requestTo,
          searchBy: 'designation'
        });
      }
    },
    searchResults: {
      handler: function() {
        if(this.sidebarStatus === 'card') {
          this.toggleSidebar(this.sidebarBeforeCardState)
        }
      },
      deep: true
    }
  },

  async created() {
    await this.processQuery();
    await this.$store.dispatch('getSearchResults');
    if (!this.searchSessionStatus && window.innerWidth > 960) {
      if (!this.sidebarStatus) this.toggleSidebar('filter');
    }
    if(window.innerWidth < 720) {
      this.$store.dispatch('setSidebarStatus', '')
    }
    if(this.modeView === 'table') {
      this.$store.dispatch('setSidebarStatus', '')
    }
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarStatus', '');
  },

  methods: {
    // TODO: Это метод для обработки кнопок с домащней страницы
    //  его надо переработать в полную функцию обработки параметров
    //  адресной строки в верные значения состояния store
    async processQuery() {
      // Обработка шаринговой ссылки
      if(this.$route.params && this.$route.params.link === 'share'){
        await this.$store.dispatch('processShareLink', this.$route.query)
        this.$router.push({name: 'search'})

        return
      }
      if (!Object.keys(this.$route.query).length) return;

      if('request' in this.$route.query) {
        this.$store.dispatch('setInitTextQuery', {
          text: this.$route.query.request,
          searchBy: 'designation'
        });

        return
      }

      await this.$store.dispatch('resetRequest');
      // Для кнопки "Бюллетень пользователя"
      if ('classifiers' in this.$route.query) {
        this.$store.dispatch('setInitTextQuery', {
          text: '',
          searchBy: 'designation'
        });
        this.$store.dispatch('setInitClassifier', {
          id: this.$route.query.classifiers,
          name: '2020' // !!!!!!!!!!!!!!!!! HARDCODE !!!!!!!!!!!!!!!!!
        });
      }

      // Для кнопки "Сравнение документов"
      if ('text' in this.$route.query) {
        this.$store.dispatch('setInitTextQuery', {
          text: this.$route.query.text,
          searchBy: this.$route.query.searchBy
        });
        const arr = [
          { field: 'type', label: 'Индекс', asc: true, active: false },
          { field: 'number', label: 'Номер', asc: true, active: false },
          { field: 'title', label: 'Наименование', asc: true, active: false },
          { field: 'approvalDate', label: 'Дата', asc: false, active: true }
        ];

        this.$store.dispatch('setInitSortOrder', arr);
      }
    },
    handleToggleMode(mode, view) {
      this.$store.dispatch('setModeView', view)
      if (view === 'table') {
        this.toggleSidebar('');
      } else {
        // TODO: Костыль, т.к. почему-то идет 2-ное срабатывание на ViewSwitch
        if (!this.sidebarStatus)
          this.$store.dispatch('setSidebarStatus', 'filter');
      }
    },
    toggleSidebar(mode = '') {
      this.$store.dispatch('setSidebarStatus', mode);
    },
    onButtonCardClick(documentId) {
      if (this.sidebarStatus === 'card') {
        if (this.currentDocumentId !== documentId) {
          this.currentDocumentId = documentId;
        } else {
          this.toggleSidebar(this.sidebarBeforeCardState);
        }
      } else {
        this.currentDocumentId = documentId;
        this.sidebarBeforeCardState = this.sidebarStatus;
        this.toggleSidebar('card');
      }
    }
  },

  metaInfo() {
    return {
      title: this.searchQuery.text ? 'Поиск: ' + this.searchQuery.text : 'Поиск'
    };
  }
};
</script>

<style src="./styles/index.css" />
